<template lang="pug">
  div
    el-dialog(
      title='TERMO DE COMPROMISSO E RESPONSABILIDADE PROFISSIONAL'
      :visible.sync='showModal'
      width='40%'
      center
    )
      .text-area(v-if="tipoCadastro === 'GEOMENSOR'")
        span
        | Sirvo-me do presente instrumento para firmar que:
        span a) atuarei na qualidade de credenciado do ITERPA para prestação de serviço de georreferenciamento de acordo com a legalidade, boa-fé e ética;
        span b) responderei legalmente por todos os atos na prestação deste serviço;
        span c) seguirei as normas legais e técnicas aplicáveis aos serviços de georreferenciamento, bem com às orientações e definições do Comitê para Análise de Georreferenciamento (CAGeo/ITERPA);
        span d) não utilizarei as marcas e símbolos oficiais do ITERPA ou do Governo do Estado do Pará para fortalecer a minha condição de credenciado;
        span e) adotarei divulgação discreta da minha condição de credenciado, a fim de não caracterizar reserva de mercado e concorrência desleal;
        span f) os documentos e as declarações que instruem o meu pedido de credenciamento são verdadeiros, tendo ciência das responsabilidades civis, criminais e administrativas.

      .text-area(v-else)
        span
        | Sirvo-me do presente instrumento para firmar que:
        span a) atuarei na qualidade de credenciado do ITERPA para prestação de serviço de vistoria de acordo com a legalidade, boa-fé e ética;
        span b) responderei legalmente por todos os atos na prestação deste serviço;
        span c) seguirei as normas legais e técnicas aplicáveis aos serviços de vistoria, bem com às orientações e definições do Comitê para Análise de Vistoria (CA-Vistoria/ITERPA);
        span d) não utilizarei as marcas e símbolos oficiais do ITERPA ou do Governo do Estado do Pará para fortalecer a minha condição de credenciado;
        span e) adotarei divulgação discreta da minha condição de credenciado, a fim de não caracterizar reserva de mercado e concorrência desleal;
        span f) os documentos e as declarações que instruem o meu pedido de credenciamento são verdadeiros, tendo ciência das responsabilidades civis, criminais e administrativas.

      el-row.paddingTop50
        el-checkbox(
          v-model='checkbox'
          label='Declaro que li e estou de acordo com os termos e cláusulas acima citados.'
          class='label'
        )

      el-row.paddingTop50(type='flex' justify='space-between')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-times
          span Cancelar
        el-button(
          type='primary'
          @click='confirmar'
          :disabled='!checkbox'
        )
          i(style='padding-right: 5px;').fa.fa-check
          span Confirmar
</template>
<script>

export default {
  props: {
    modalOpen: {
      type: Boolean,
      default: false,
    },
    tipoCadastro: {
      type: String,
      default: 'GEOMENSOR'
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  data() {
    return {
      checkbox: false,
    }
  },

  methods: {
    fecharModal() {
      this.$emit('close-modal');
    },
    confirmar() {
      this.$emit('confirmar');
    }
  }
}
</script>
<style lang="scss" scoped>

.text-area {
  background-color: #e6e6e6;
  font-size: 16px;
  font-weight: bold;
  padding-left: 10px;
  border-radius: 10px;
  padding: 30px 10px 30px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 300px;
}

.label {
  font-size: 16px;
  font-weight: bold;
}

.paddingTop50 {
  padding-top: 50px;
}

</style>
